module.exports = __webpack_public_path__ + "static/img/013.6d73c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/013.png
// module id = ozMD
// module chunks = 1